import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { findAppsQueryKeyFactory } from "app/pages/sales-intelligence/pages/find-apps/query/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { AppsColumnConfigDto } from "app/pages/sales-intelligence/store/find-apps/types/dto";

export const useColumnsConfigQuery = <T = AppsColumnConfigDto>(
    appSourceType: AppsSourceType,
    select?: (data: AppsColumnConfigDto) => T,
) => {
    return useQuery<AppsColumnConfigDto, unknown, T>({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: findAppsQueryKeyFactory.columnConfig(appSourceType),
        placeholderData: keepPreviousData,
        select,
        queryFn({ signal }) {
            return salesApiService.findApps[appSourceType].fetchColumnConfig({ cancellation: signal });
        },
    });
};
